import { DESKTOP_FOOTER_ID, DESKTOP_HEADER_ID, MOBILE_HEADER_ID, MOBILE_NAVBAR_ID } from './constants';

export const getFooterHeight = () => {
  // NOTE: based on the "useScreen" hook
  const isMobile = window.innerWidth <= 760;

  if (isMobile) {
    const mobileNavigation = document.getElementById(MOBILE_NAVBAR_ID);
    return mobileNavigation?.getBoundingClientRect().height - 5 || 0;
  }

  const desktopFooter = document.getElementById(DESKTOP_FOOTER_ID);
  return desktopFooter?.getBoundingClientRect().height || 0;
};

export const getHeaderHeight = () => {
  // NOTE: based on the "useScreen" hook
  const isMobile = window.innerWidth <= 760;

  if (isMobile) {
    const mobileHeader = document.getElementById(MOBILE_HEADER_ID);
    return mobileHeader?.getBoundingClientRect().height || 0;
  }

  const desktopHeader = document.getElementById(DESKTOP_HEADER_ID);
  return desktopHeader?.getBoundingClientRect().height || 0;
};

export const getContentHeight = () => {
  // NOTE: based on the "useScreen" hook

  const footerHeight = getFooterHeight();
  const headerHeight = getHeaderHeight();

  return window.innerHeight - headerHeight - footerHeight;
};
